import React from "react";

// Decorative retro pixel-art scene for the hero:
// an AI build/deploy terminal with code "typing" in, an AI spark,
// a deploy progress bar, and a rocket "shipping" — tying to
// "AI-Powered Digital Products That Actually Ship".
// Palette matches the site's ink/gold/red/green brand tokens.
const STARS = [
  { x: 60, y: 14 },
  { x: 96, y: 8 },
  { x: 150, y: 46 },
  { x: 170, y: 16 },
  { x: 200, y: 30 },
  { x: 212, y: 70 },
];

const CODE_LINES = [
  { y: 58, w: 78, fill: "#3E7FB8", delay: "0s" },
  { y: 70, w: 58, fill: "#8B7F70", delay: "0.3s" },
  { y: 82, w: 90, fill: "#4E9E3C", delay: "0.6s" },
  { y: 94, w: 46, fill: "#C2312A", delay: "0.9s" },
];

const PixelHeroScene = () => (
  <svg
    className="pixel-scene"
    viewBox="0 0 230 160"
    role="img"
    aria-label="Pixel-art animation of an AI build terminal deploying a product as a rocket launches"
    preserveAspectRatio="xMidYMid meet"
  >
    {/* night sky + ground */}
    <rect x="0" y="0" width="230" height="160" fill="#251E17" />
    <rect x="0" y="130" width="230" height="4" fill="#3F352B" />
    <rect x="0" y="134" width="230" height="26" fill="#1D1712" />

    {/* twinkling stars */}
    {STARS.map((s, i) => (
      <rect
        key={i}
        className="pixel-twinkle"
        x={s.x}
        y={s.y}
        width="4"
        height="4"
        fill="#F2C14E"
        style={{ animationDelay: `${i * 0.35}s` }}
      />
    ))}

    {/* build / deploy terminal window */}
    <rect
      x="16"
      y="34"
      width="112"
      height="74"
      fill="#FAF8F3"
      stroke="#0F0C09"
      strokeWidth="4"
    />
    <rect x="16" y="34" width="112" height="14" fill="#0F0C09" />
    <rect x="24" y="38" width="6" height="6" fill="#C2312A" />
    <rect x="36" y="38" width="6" height="6" fill="#E8A70F" />
    <rect x="48" y="38" width="6" height="6" fill="#4E9E3C" />

    {/* code lines that "type" in on a loop */}
    {CODE_LINES.map((l, i) => (
      <g
        key={i}
        className="pixel-type"
        style={{ animationDelay: l.delay }}
      >
        <rect x="26" y={l.y} width={l.w} height="6" fill={l.fill} />
      </g>
    ))}

    {/* AI spark inside the window */}
    <g className="pixel-twinkle" style={{ animationDelay: "0.5s" }}>
      <rect x="106" y="56" width="6" height="6" fill="#F2C14E" />
      <rect x="106" y="48" width="6" height="6" fill="#E8A70F" />
      <rect x="106" y="64" width="6" height="6" fill="#E8A70F" />
      <rect x="98" y="56" width="6" height="6" fill="#E8A70F" />
      <rect x="114" y="56" width="6" height="6" fill="#E8A70F" />
    </g>

    {/* deploy progress bar */}
    <rect
      x="16"
      y="114"
      width="112"
      height="12"
      fill="#FAF8F3"
      stroke="#0F0C09"
      strokeWidth="4"
    />
    <rect
      className="pixel-deploy"
      x="20"
      y="118"
      width="104"
      height="4"
      fill="#4E9E3C"
    />

    {/* rocket "shipping" */}
    <g className="pixel-rocket">
      <polygon points="185,44 174,64 196,64" fill="#C2312A" />
      <rect
        x="174"
        y="64"
        width="22"
        height="32"
        fill="#FAF8F3"
        stroke="#0F0C09"
        strokeWidth="3"
      />
      <rect
        x="180"
        y="72"
        width="10"
        height="10"
        fill="#3E7FB8"
        stroke="#0F0C09"
        strokeWidth="2"
      />
      <polygon points="174,86 166,100 174,100" fill="#C2312A" />
      <polygon points="196,86 204,100 196,100" fill="#C2312A" />

      {/* alternating flame for flicker */}
      <g className="pixel-flame-a">
        <polygon points="178,96 192,96 185,116" fill="#E8A70F" />
        <polygon points="181,96 189,96 185,108" fill="#C2312A" />
      </g>
      <g className="pixel-flame-b">
        <polygon points="179,96 191,96 185,108" fill="#F2C14E" />
        <polygon points="182,96 188,96 185,103" fill="#A82720" />
      </g>
    </g>

    {/* falling exhaust pixels */}
    <rect
      className="pixel-exhaust"
      x="178"
      y="110"
      width="4"
      height="4"
      fill="#8B7F70"
      style={{ animationDelay: "0s" }}
    />
    <rect
      className="pixel-exhaust"
      x="188"
      y="112"
      width="4"
      height="4"
      fill="#8B7F70"
      style={{ animationDelay: "0.33s" }}
    />
    <rect
      className="pixel-exhaust"
      x="183"
      y="116"
      width="4"
      height="4"
      fill="#5C5044"
      style={{ animationDelay: "0.66s" }}
    />
  </svg>
);

export default PixelHeroScene;
